import { FC } from "react"

export const CoherentMiniIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80392 0.15625C4.37157 0.260732 0 4.69745 0 10.1553C0 15.6787 4.47715 20.1562 10 20.1562C15.5228 20.1562 20 15.6787 20 10.1553L15.2941 10.1553C15.2941 13.0794 12.9239 15.4499 10 15.4499C7.07615 15.4499 4.7059 13.0794 4.7059 10.1553C4.7059 7.29682 6.97091 4.96741 9.80392 4.86425V0.15625Z"
        fill="currentColor"
      />
      <rect x="14.6875" width="5.3125" height="5.3125" fill="currentColor" />
    </svg>
  )
}

